import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col font-sans bg-white">
      <Navbar />
      {/* 
        The main content container ensures content starts below the fixed header 
        and maintains a clean stacking context.
      */}
      <main className="flex-grow pt-24 md:pt-32 relative z-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;